module.exports =`
<table style="width: 300px; color: #212529; font-family: Arial; border:0; border-spacing: 0px;">
<tbody>
<tr style="height: 17px;">
<td style="vertical-align: top; width: 65px;" rowspan="5">
<img src="https://assets.enchantchristmas.com/web/labs_icon.png" alt="" width="50" height="50"></td>
<td style="height: 16px; width: 265px; font-family: Arial; font-size: 13px; vertical-align: bottom; mso-line-height-rule: exactly; line-height:8px;">
<b>{{name}}</b></td>
</tr>
<tr style="height: 15px;">
<td style="height: 15px; width: 265px; font-family: Arial; font-size: 10px; text-transform: uppercase; vertical-align: top; padding-top: 2px;">
{{title}}</td>
</tr>
<tr style="height: 12px;">
<td style="height: 12px; width: 265px; font-family: Arial;font-size: 10px; mso-line-height-rule: exactly; line-height:10px; padding-bottom: 5px;">
{{phone}} / www.enchantlabs.io</td>
</tr>
</tbody>
</table>
`
